import { render, staticRenderFns } from "./bdd-checklists.vue?vue&type=template&id=5be49b3e"
import script from "./bdd-checklists.vue?vue&type=script&lang=js"
export * from "./bdd-checklists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports